import React from 'react';
import logo from '../assets/images/C_logo.png';

const ListFinishedItem = (props) => {

    return (
      <div className='list-item__loading mb-3'>
        <img className="image-fluid last-item__logo" alt="logo" src={logo}/>
      </div>
    );
}


export default ListFinishedItem;